import { render, staticRenderFns } from "./TeacherSelector.vue?vue&type=template&id=3f806713&scoped=true&"
import script from "./TeacherSelector.vue?vue&type=script&lang=ts&"
export * from "./TeacherSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f806713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f806713')) {
      api.createRecord('3f806713', component.options)
    } else {
      api.reload('3f806713', component.options)
    }
    module.hot.accept("./TeacherSelector.vue?vue&type=template&id=3f806713&scoped=true&", function () {
      api.rerender('3f806713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teachers/TeacherSelector.vue"
export default component.exports